import React, { ChangeEvent, ReactElement } from "react";
import InputLabel from "../InputLabel";
const StyledInput = ({
  id,
  type,
  name,
  placeholder,
  className,
  value,
  onChange,
  onKeyDown,
}: {
  id: string;
  type?: "text" | "number";
  name?: string;
  placeholder?: string;
  className?: string;
  value?: string | number | null;
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
  onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
}): ReactElement => {
  const coreStyles = `rounded h-[50px]  ${
    id == "commodity" ? "pl-6" : "pl-3"
  } border-solid bg-gray-125 outline-none border-b-2 border-gray-500 w-full sm:w-full md:w-full lg:w-[120px] xl:w-[170px] 2xl:w-[200px] `;
  const enabledStyles =
    "focus:text-blue-900 focus:border-CostcoAction-focus focus:py-2 focus:pl-1";
  const hideNumberSpinner = `input[type=number]::-webkit-inner-spin-button, input[type=number]::-webkit-outer-spin-button {-webkit-appearance:none;margin:0}  `;

  return (
    <div>
      <style>{hideNumberSpinner}</style>
      <div className="mx-2 block">
        <InputLabel
          id={`input-label-${id.toLowerCase().replace(/\s+/g, "-")}`}
          label={id}
          className={"text-nowrap overflow-x-auto"}
        />
        <input
          name={name}
          id={id}
          data-testid={`styled-input-${id.toLowerCase().replace(/\s+/g, "-")}`}
          className={`${coreStyles}${className} ${enabledStyles}`}
          value={value ?? ""}
          onChange={onChange}
          onKeyDown={onKeyDown}
          placeholder={placeholder}
          type={type ?? "text"}
        />
      </div>
    </div>
  );
};

export default StyledInput;
